import React from "react";

interface PasswordRequirementsProps {
    password: string;
}

const PasswordRequirements: React.FC<PasswordRequirementsProps> = ({ password }) => {
    const requirements = [
        { regex: /.{8,}/, message: "Password must be at least 8 characters long." },
        { regex: /[A-Z]/, message: "Password must contain at least one uppercase letter." },
        { regex: /[a-z]/, message: "Password must contain at least one lowercase letter." },
        { regex: /[0-9]/, message: "Password must contain at least one digit." },
        { regex: /[@$!%*?&]/, message: "Password must contain at least one special character (@, $, !, %, *, ?, &)." },
    ];

    return (
        <div className="mt-4">
            <ul className="list-disc pl-5 space-y-1">
                {requirements.map(({ regex, message }, index) => (
                    <li
                        key={index}
                        className={`requirements text-sm ${
                            regex.test(password) ? "text-green-500" : "text-red-500"
                        }`}
                    >
                        {message}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default PasswordRequirements;
